import { render, staticRenderFns } from "./DadosEndereco.vue?vue&type=template&id=79f9d4a0"
import script from "./DadosEndereco.vue?vue&type=script&lang=js"
export * from "./DadosEndereco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports